import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H1, H2, BlueButton } from '../../StyledComponents';
import Check from '../../../assets/v2/Hardware/green_tick.svg';
import { StaticQuery, graphql, navigate } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import lottie, { AnimationItem } from 'lottie-web';
import EnhancedBadge from '../../../assets/v2/Hardware/enhanced-curve.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HardwareForm from '../../../templates/hardwareComponents/OdroidSectionFour';
import Heart from '../../../assets/v2/Hardware/HeartFilled.svg';

import { Modal, ModalContent } from '../AndroidX86/KioskSectionFive';

const Section = styled(SectionParent)`
  background-color: #f9fbfe;
  padding-top: 10rem !important;
  padding-bottom: 3rem !important;
  @media (max-width: 520px) {
    padding-top: 8rem !important;
    padding-bottom: 0rem !important;
  }
`;

const SectionTwo = styled(SectionParent)`
  background-color: #f9fbfe;
  padding-top: 5rem !important;
  padding-bottom: 3rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;

const BlueButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  /* justify-content: center; */
  display: flex;
  margin-top: 2rem;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;

const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 768px) {
    padding-bottom: 1rem;
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  align-self: center;
  max-width: 80%;
  grid-column: span 2;

  @media (min-width: 768px) {
    margin-left: 5%;
  }
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    margin-bottom: 3rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;

const BodyTextTwo = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.69;
  letter-spacing: normal;
  color: #4f5263;
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #ffffff;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 100%;
    text-align: center;
  }
`;

const ImageLander = styled.div`
  width: 280px;
  height: 280px;
  margin-left: 14rem;
  margin-top: 6rem;
  border-radius: 280px;
  background-color: #e0f0ff;

  @media (max-width: 768px) {
    display: none;
  }
`;
const SectionTitle = styled(H1)`
  text-align: left;
  font-size: 48px !important;
  max-width: 12em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 700px) {
    text-align: center;
    font-size: 24px !important;
  }
`;
const SectionTitleTwo = styled(H1)`
  text-align: left;
  font-size: 36px;
  max-width: 12em;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
`;
const BodyText = styled.div`
  font-size: 24px;
  max-width: 20em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.51;
  margin-top: 1rem;
  letter-spacing: normal;
  color: #4f5263;

  @media (max-width: 700px) {
    text-align: center;
    font-size: 18px;
    margin-bottom: 2rem;
  }
`;

const BodyTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  padding: 1.5rem 0;
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const TargetImage = styled(GatsbyImage)`
  width: 90%;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-column: span 2;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
`;
const FormComponentLeftList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0.5em;
  list-style: none;
  @media (max-width: 520px) {
    padding-top: 1rem;
    display: grid;
    justify-content: center;
  }
`;

const FormComponentLeftListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #7f8495;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
  @media (max-width: 520px) {
    text-align: left;
  }
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const BannerMobile = styled(LazyLoadImage)`
  display: none;
  @media (max-width: 768px) {
    width: 225px;
    justify-self: right;
    display: unset;
    padding-bottom: 2rem;
  }
`;

const BannerContainer = styled(LazyLoadImage)`
  width: 185px;
  margin-left: 2rem;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

// padding: 0rem 14rem;
//   @media (max-width: 1680px) and (min-width: 1440px) {
//     padding: 0rem 10rem;
//   }
// @media (max-width: 1440px) and (min-width: 768px) {
//   padding: 0rem 5rem;
// }
// @media (max-width: 768px) {
//   padding-top: 9px;
//   padding-left: 2rem;
//   padding-right: 2rem;
// }
// @media (max-width: 520px) {
//   padding: 1rem;
// }
const AnimationContainer = styled.div`
  width: 20.5vw;
  /* min-width: 233px; */
  @media (max-width: 1000px) and (min-width: 768px) {
    /* width: 15rem; */
  }
  ${(props: {
    isFixed: boolean;
    percentage: number;
    containerMiddle: number;
  }) =>
    props.isFixed
      ? `
    position: fixed;
    top: 33rem;
      left: calc(19rem + ${((100 - props.percentage / 8) / 100) * 14}%);
    @media (max-width: 1680px) and (min-width: 1440px) {

    top: 32rem;
      left: calc(16rem + ${((100 - props.percentage / 8) / 100) * 14}%);
    }
    @media (max-width: 1580px) and (min-width: 1440px) {
      top: 28rem;
    }
    @media (max-width: 1440px) and (min-width: 1000px) {
      top: 32rem;
      left: calc(12rem + ${((100 - props.percentage / 8) / 100) * 14}%);
    }

    @media (max-width: 1320px) and (min-width: 1280px) {
      top: 30rem;
    }
    @media (max-width: 1280px) and (min-width: 1000px) {
      top: 28rem;
      left: calc(10rem + ${((100 - props.percentage / 8) / 100) * 14}%);

    }
    @media (max-width: 1160px) and (min-width: 1000px) {
      top: 26rem;
    }
    @media (max-width: 1000px) and (min-width: 768px) {
      left: calc(8rem + ${((100 - props.percentage / 8) / 100) * 14}%);

      top: 21rem;
    }
    @media (max-width: 768px) {
      display: none;
    }
    `
      : `
      position: absolute;
      top: calc(8rem + ${props.containerMiddle}px);
      left: calc(20rem + 13%);
      @media (max-width: 1680px) and (min-width: 1440px) {

        top: calc(12rem + ${props.containerMiddle}px);
        left: calc(18rem + 13%);
}
@media (max-width: 1440px) and (min-width: 1000px) {
      left: calc(12rem + 13%);
      top: calc(15rem + ${props.containerMiddle}px);
}
@media (max-width: 1000px) and (min-width: 768px) {
      left: calc(8rem + 13%);

      top: calc(5rem + ${props.containerMiddle}px);
}
@media (max-width: 768px) {
  display: none;
}
      `}
`;

const AnimationContainerMobile = styled.div`
  width: 80%;
  max-width: 280px;
  margin: auto;
  @media (min-width: 768px) {
    display: none;
  }
`;

const HeartSection = styled.div`
  position: absolute;
  right: 10rem;
  display: grid;
  grid-template-columns: auto auto;
  top: 7rem;
  @media (max-width: 768px) {
    right: 7rem;
  }
  @media (max-width: 650px) {
    display: none;
  }
`;

const HeartSectionMobile = styled(HeartSection)`
  display: none;
  @media (max-width: 650px) {
    display: grid;
    right: 3rem;
    top: 5rem;
    height: 1rem;
  }
`;

const WishNumber = styled.div`
  padding: 3px;
  font-size: 14px;
  box-shadow: 0 1px 4px 0 #8392aa;
  border-radius: 15px;
  width: 22px;
  height: 22px;
  margin-left: 1rem;
  text-align: center;
  display: grid;
  align-content: center;
  background: #ff8686;
`;

const WishList = styled.div`
  padding-right: 1rem;
  align-self: end;
  cursor: default;
`;

export default class HardwareSectionOne extends React.Component<any, any> {
  animation?: AnimationItem;
  animationmobile?: AnimationItem;
  isCMounted = true;

  state = {
    isFixed: true,
    percentage: 0,
    containerMiddle: 0,
  };

  componentDidMount() {
    this.props.updateWishList();

    this.animation = lottie.loadAnimation({
      name: 'animation-kiosk',
      container: document.getElementById('hardware-animation-two')!,
      loop: false,
      renderer: 'svg',
      autoplay: false,
      animationData: require('../../lottieAnimations/hardware_page_home.json'),
    });

    this.animationmobile = lottie.loadAnimation({
      name: 'animation-kiosk-mobile',
      container: document.getElementById('hardware-animation-mobile')!,
      loop: false,
      renderer: 'svg',
      autoplay: true,
      animationData: require('../../lottieAnimations/hardware_page_home.json'),
    });

    window.onscroll = this.scrollFunction;
  }

  scrollFunction = () => {
    // Get the header
    const header = document.getElementById('section-one-two');
    const lander = document.getElementById('image-lander');
    if (header && this.isCMounted) {
      // Get the offset position of the navbar
      const containerTop = header!.offsetTop;
      const containerBottom = header!.offsetTop + header!.offsetHeight;
      // const containerBottom = header!.offsetTop + header!.clientHeight;
      const currentBottomPosition = window.pageYOffset + window.innerHeight;
      const currentTopPosition = window.pageYOffset;
      // console.log(
      //   'currentTopPosition + containerTop',
      //   currentTopPosition + containerTop
      // );
      // console.log(
      //   'lander!.offsetTop +  lander!.offsetHeight',
      //   lander!.offsetTop + lander!.offsetHeight
      // );
      if (
        currentTopPosition + containerTop >
        lander!.offsetTop + lander!.offsetHeight * 1.5
        // ||(currentTopPosition < containerTop &&
        //   currentBottomPosition >= containerBottom)
      ) {
        this.animation!.play();
        this.setState({
          isFixed: false,
          // percentage: 100,
          containerMiddle: containerTop,
        });
        // console.log('animation complete bottom');
      } else if (
        currentBottomPosition > containerTop &&
        currentTopPosition < containerTop
      ) {
        // lottie.play('animation-kiosk')
        const scrollPercent = (91 * currentTopPosition) / containerTop;
        const scrollRounded = Math.round(scrollPercent);
        // console.log('totalFrames', this.animation?.totalFrames);
        // console.log('currentFrame', this.animation?.currentFrame);
        this.setState({
          isFixed: true,
          // percentage: (currentTopPosition / containerTop) * 100,
        });
        this.animation!.goToAndStop(
          scrollRounded < 20 ? 0 : scrollRounded - 20,
          true
        );
      } else {
        this.animation!.goToAndStop(91, false);
        this.setState({ percentage: 0 });
        // console.log('animation complete');
      }
    }
  };

  OpenModal = (event: any) => {
    event.stopPropagation();
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'block';
    }
  };
  CloseModal = (event: any) => {
    const modal = document.getElementById('myModal');
    if (modal !== null) {
      modal.style.display = 'none';
    }
  };
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            hardwareHome: file(
              relativePath: { eq: "v2/CustomHardware/hardware_home.png" }
            ) {
              childImageSharp {
                fluid(quality: 85) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
            hardwareHomeMobile: file(
              relativePath: { eq: "v2/CustomHardware/hardware_home_mobile.png" }
            ) {
              childImageSharp {
                fluid(quality: 85) {
                  aspectRatio
                  src
                  srcSet
                  sizes
                  srcWebp
                  srcSetWebp
                }
              }
            }
          }
        `}
        render={(data: any) => (
          <>
            <Modal id="myModal" className="modal">
              <ModalContent className="modal-content">
                <span
                  className="close"
                  onClick={this.CloseModal}
                  style={{
                    display: 'grid',
                    justifyContent: 'end',
                    cursor: 'pointer',
                  }}
                >
                  &times;
                </span>
                <HardwareForm endState={'/hardware-requirements/submitted'} />
              </ModalContent>
            </Modal>
            <Section>
              <Grid>
                <ImgWrapper>
                  <TargetImage
                    alt="Esper Hardware"
                    loading="lazy"
                    fluid={[
                      data.hardwareHomeMobile.childImageSharp.fluid,
                      {
                        ...data.hardwareHome.childImageSharp.fluid,
                        media: `(min-width: 768px)`,
                      },
                    ]}
                  />
                  <AnimationContainer
                    isFixed={this.state.isFixed}
                    containerMiddle={this.state.containerMiddle}
                    percentage={this.state.percentage}
                    id="hardware-animation-two"
                  />
                </ImgWrapper>
                <HeartSectionMobile
                  onClick={() => navigate('/wishlist')}
                  style={{ cursor: 'pointer' }}
                >
                  <WishList>Wishlist</WishList>
                  <div>
                    <WishNumber>{this.props.wishArray.length}</WishNumber>
                    <img src={Heart} />
                  </div>
                </HeartSectionMobile>
                <HeartSection onClick={() => navigate('/wishlist')}>
                  <WishList>Wishlist</WishList>
                  <div>
                    <WishNumber>{this.props.wishArray.length}</WishNumber>
                    <img src={Heart} />
                  </div>
                </HeartSection>
                <GridItem>
                  <SectionTitle>
                    Pick the Right Android Hardware for Your Application
                  </SectionTitle>
                  <BodyText>
                    Disrupt Your Industry with a Smarter Approach to Device
                    Selection
                  </BodyText>

                  <BlueButtonWrapper>
                    <BlueButton
                      id="hardware__tell_us"
                      onClick={this.OpenModal}
                      style={{
                        marginLeft: '0',
                        backgroundColor: '#725cbd',
                        textTransform: 'none',
                      }}
                    >
                      Tell us your requirements
                    </BlueButton>
                  </BlueButtonWrapper>
                </GridItem>
              </Grid>
            </Section>
            <SectionTwo id="section-one-two">
              <Grid>
                <ImgWrapper>
                  <ImageLander id="image-lander" />

                  <AnimationContainerMobile id="hardware-animation-mobile" />
                </ImgWrapper>
                <GridItem>
                  <BannerMobile src={EnhancedBadge} />
                  <HeaderSection>
                    <SectionTitleTwo>
                      Esper Enhanced <br />
                      Android Devices
                    </SectionTitleTwo>
                    <BannerContainer src={EnhancedBadge} />
                  </HeaderSection>
                  <BodyTextTwo>
                    Esper Enhanced Android Devices are shipped with a customized
                    Android OS for performance, faster deployment, and superior
                    debugging. Esper tailors the OS to the specific needs of
                    purpose-built device creators, including in-ROM apps and
                    peripheral support.
                  </BodyTextTwo>
                  <BodyTitle>
                    Benefits of Using Esper Enhanced Hardware
                  </BodyTitle>
                  <SectionContent>
                    <FormComponentLeftList>
                      <FormComponentLeftListItem>
                        OS customization
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Seamless Updates{' & '}Patching
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Improved performance
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Increased security
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        No-Touch Provisioning
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Device Telemetry
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Remote Debugging
                      </FormComponentLeftListItem>
                      <FormComponentLeftListItem>
                        Full DevOps Infrastructure
                      </FormComponentLeftListItem>
                    </FormComponentLeftList>
                  </SectionContent>
                </GridItem>
              </Grid>
            </SectionTwo>
          </>
        )}
      />
    );
  }
}
